import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-5" />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" data-id="element-6">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-navy" data-id="element-7">
          <h2 className="text-xl font-bold text-gold font-playfair" data-id="element-8">{title}</h2>
          <button onClick={onClose} className="text-gray-300 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" aria-label="Cerrar" data-id="element-9">
            <XIcon className="w-6 h-6" data-id="element-10" />
          </button>
        </div>
        <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(85vh-64px)] text-navy text-sm leading-relaxed space-y-4" data-id="element-11">
          {children}
        </div>
      </div>
    </div>;
}